import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=543f0334&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543f0334",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('543f0334')) {
      api.createRecord('543f0334', component.options)
    } else {
      api.reload('543f0334', component.options)
    }
    module.hot.accept("./Home.vue?vue&type=template&id=543f0334&scoped=true&", function () {
      api.rerender('543f0334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/Home.vue"
export default component.exports